import fetch from '~~/common/js/universal/fetch';
import globalStorePlugin from '~~/common/vue/store/global';
import userStorePlugin from '~~/common/vue/store/user';
import browserStorePlugin from '~~/common/vue/store/browser';
import searchStorePlugin from '~~/search/common/vue/store/search';
import notificationsStorePlugin from '~~/common/vue/components/notifications/store';

export const plugins = [
  globalStorePlugin,
  userStorePlugin,
  browserStorePlugin,
  searchStorePlugin,
  notificationsStorePlugin,
];

export const state = () => ({
  count: 0,
  error: null,
  pages: 1,
  results: [],
  queryExpansions: [],
  endOfFeed: false,
  fetchError: false,
});

export const getters = {
  hasResults: ({ results, error }) => Boolean(results && results.length && !error),
};

export const mutations = {
  setResults(st, results) {
    st.results = results;
  },
  setQueryExpansions(st, queryExpansions) {
    st.queryExpansions = queryExpansions;
  },
  addResults(st, newResults) {
    st.results.push(...newResults);
  },
  setMeta(st, { count, pages }) {
    Object.assign(st, { count, pages });
  },
  setError(st, error) {
    st.error = error;
  },
  setEndOfFeed(st) {
    st.endOfFeed = true;
  },
  setFetchError(st, error) {
    st.fetchError = error;
  },
};

const fetchResultsWithOperation = async ({ commit }, payload) => {
  const { url, operation, throwFetchError = false } = payload;
  try {
    const response = await fetch(url, { headers: { 'Content-Type': 'application/json' } });
    const { images } = await response.json();
    commit(`${operation}Results`, images);
  } catch (err) {
    if (throwFetchError) {
      commit('setFetchError', true);
    } else {
      commit('setError', true);
    }
  }
};

export const actions = {
  async nuxtServerInit({ commit, dispatch }, context) {
    dispatch('global/nuxtServerInit', context);
    await dispatch('user/nuxtServerInit', context);
    const { results, resultsError } = context.req;
    if (resultsError) {
      commit('setError', resultsError);
      return;
    }
    if (!results) {
      return;
    }
    const { meta, images } = results;
    if (images) {
      // sanitize the image data here so encoding issues
      // don't break CSP when the Vuex state is delivered to the client
      // via an inline script.
      commit('setResults', images);
      commit('setQueryExpansions', meta.queryExpansions);
    }
    if (meta) {
      commit('setMeta', {
        count: meta.totalEstimatedMatches,
        pages: meta.totalNumberOfPages,
      });
    }
  },
  async fetchNextPage({ commit }, url) {
    await fetchResultsWithOperation({ commit }, { url, operation: 'add', throwFetchError: true });
  },
};
